import { _longPressDisplayTypes } from 'global/wrappers/LongPressWrapper';
import React, { createContext, useState } from 'react'
import { useSearchParams } from 'react-router-dom';

export const LongPressContext = createContext();

export const LongPressProvider = (
  {
    children,
    longPressDisplayType = _longPressDisplayTypes.full,
    longPressType,
    disallowLpw,
  }
) => {


  const [, setSearchParams] = useSearchParams();

  const [showLongPressModal, setShowLongPressModal] = useState()

  const handleShowLongPressModal = () => {
    if (disallowLpw) return;
    // setSearchParams({ ['team']: 'teamKey' })
    // console.log('longPressType', longPressType)
    setShowLongPressModal(!showLongPressModal)
  }

  return (
    <LongPressContext.Provider
      value={{
        longPress_state: {
          longPressType,
          longPressDisplayType,
          showLongPressModal,
        },
        longPress_handlers: {
          handleCancel: handleShowLongPressModal,
          handleShowLongPressModal
        }
      }}>
      {children}
    </LongPressContext.Provider>
  )
}
